import { Text } from "@clipboard-health/ui-components";
import { Box, Stack } from "@mui/material";
import { type PlacementCandidate } from "@src/appV2/redesign/PlacementCandidate/types";

import { type PlacementForComputedPay } from "../../lib/usePayTransparencyRates";
import { type TransparencyPayRate } from "../../types/payRate";
import { PayAndScheduleFormV2 } from "../PayAndScheduleFormV2/PayAndScheduleFormV2";

interface PayDetailsStepProps {
  placementForComputedPay: PlacementForComputedPay;
  placementCandidate: PlacementCandidate;
  transparencyPayRates: TransparencyPayRate[];
  applicationQualification: string | undefined;
  highestMatchingQualification: string | undefined;
  workerId: string;
}

export function PayDetailsStep(props: PayDetailsStepProps) {
  const {
    placementForComputedPay,
    placementCandidate,
    transparencyPayRates,
    applicationQualification,
    highestMatchingQualification,
    workerId,
  } = props;

  return (
    <Box sx={{ px: 5, py: 6 }}>
      <Stack spacing={8}>
        <Stack spacing={5}>
          <Text variant="h3" textAlign="center">
            Your pay rates
          </Text>
          <Text gutterBottom variant="body1" textAlign="center">
            We&apos;ve calculated your pay at this facility, based on your years of experience and
            preferences.
          </Text>
        </Stack>
        <PayAndScheduleFormV2
          transparencyPayRates={transparencyPayRates}
          highestMatchingQualification={
            applicationQualification ?? highestMatchingQualification ?? ""
          }
          placement={placementForComputedPay}
          placementCandidate={placementCandidate}
          workerId={workerId}
          isYearsOfExperienceEditable={false}
        />
        {/* Footer buttons handled in parent StickyFooter */}
      </Stack>
    </Box>
  );
}
